<template>
  <div class="border border-solid border-primary/30 rounded-8 bg-primary/5 p-3 mb-4">
    <div class="text-12 font-600 text-primary mb-2 flex items-center gap-x-1">
      <Icon name="memory" class="w-4 h-4" />
      Tool Definition (Agent)
    </div>
    <FormInput v-if="!selfDescribing" v-model="localDescription" label="Tool Description" class="w-full" placeholder="Describe when the agent should use this tool" @update:modelValue="emit" />
    <div v-else class="text-11 text-gray-400 mb-1">This tool describes itself to the agent. Its built-in description is always used.</div>
    <FormSelect v-model="localPolicy" label="Policy" :options="policyOptions" :reduce="(o) => o.value" :clearable="false" class="w-full mt-2" @update:modelValue="emit" />
    <div class="text-11 text-gray-400 mt-1">
      <span v-if="localPolicy === 'confirm'">Pauses for human approval before this tool runs.</span>
      <span v-else-if="localPolicy === 'off'">Disabled — the agent cannot use this tool.</span>
      <span v-else>Runs automatically when the agent decides to use it.</span>
    </div>
  </div>
</template>

<script>
// Tools with real-world side effects default to "Require approval".
const CONFIRM_BY_DEFAULT = ['action-send-email', 'action-execute-api', 'action-invoke-flow', 'action-schedule'];

// These tools expose their own built-in descriptions at runtime, so a user-authored
// description is neither shown nor stored — only the approval policy is configurable.
const SELF_DESCRIBING = ['data-transform', 'data-chart', 'data-adapter'];

export default {
  name: 'AgentToolDefinitionSection',
  props: {
    toolDescription: { type: String, default: '' },
    policy: { type: String, default: '' },
    toolType: { type: String, default: '' },
  },
  emits: ['update'],
  data() {
    return {
      localDescription: this.toolDescription,
      localPolicy: this.policy || this.defaultPolicy(),
    };
  },
  computed: {
    selfDescribing() {
      return SELF_DESCRIBING.includes(this.toolType);
    },
    policyOptions() {
      return [
        { label: 'Automatic', value: 'auto' },
        { label: 'Require approval', value: 'confirm' },
        { label: 'Disabled', value: 'off' },
      ];
    },
  },
  methods: {
    defaultPolicy() {
      return CONFIRM_BY_DEFAULT.includes(this.toolType) ? 'confirm' : 'auto';
    },
    emit() {
      // Name + return type are derived from the block at runtime. Self-describing
      // tools keep their built-in description, so we clear any authored one.
      this.$emit('update', { tool_description: this.selfDescribing ? '' : this.localDescription, policy: this.localPolicy });
    },
  },
  watch: {
    toolDescription(v) {
      this.localDescription = v;
    },
    policy(v) {
      this.localPolicy = v || this.defaultPolicy();
    },
  },
};
</script>
